import isEmpty from "lodash-es/isEmpty";

import Swal from "sweetalert2";

export function showPrompt(title, text, defaultText, onOK = null) {
  return Swal.fire({
    title: title,
    text: text,
    input: "text",
    confirmButtonText: "OK",
    inputValue: defaultText,
    showCancelButton: true,
  }).then((result) => {
    if (result.isConfirmed && onOK) {
      return onOK(result.value);
    }
  });
}

export function showDialog(title, text, icon = "info", onOK = null) {
  return Swal.fire({
    title: title,
    text: text,
    icon: icon,
    confirmButtonText: "OK",
  }).then((result) => {
    if (onOK) {
      return onOK();
    }
  });
}

export function showDialogHtml(title, html, icon = "info", onOK = null) {
  return Swal.fire({
    title: title,
    html: html,
    icon: icon,
    confirmButtonText: "OK",
  }).then((result) => {
    if (onOK) {
      return onOK();
    }
  });
}

/**
 * options are value:text pairs
 * @param {*} options
 * @returns
 */
export function showOptions(title, placeholder, options) {
  return Swal.fire({
    title: title,
    input: "select",
    inputOptions: options,
    inputPlaceholder: placeholder,
    showCancelButton: true,
  });
}

export function showSuccess(title, text, onOK = null) {
  return showDialog(title, text, "success", onOK);
}

export function showSuccessHtml(title, html, onOK = null) {
  return showDialogHtml(title, html, "success", onOK);
}

export function showError(title, text, onOK = null) {
  return showDialog(title, text, "error", onOK);
}

export function showInfo(title, text, onOK = null) {
  return showDialog(title, text, "info", onOK);
}

export function showErrorMulti(title, errors, onOK = null) {
  return showMulti("error", title, errors, onOK);
}

export function showWarningMulti(title, errors, onOK = null) {
  return showMulti("warning", title, errors, onOK);
}
export function showMulti(icon, title, errors, onOK = null) {
  let header = "Errors";

  if (icon === "warning") {
    header = "Warnings";
  }
  return Swal.fire({
    title,
    icon,
    confirmButtonText: "OK",
    width: 800,
    html: `
    <div style="max-height:400px; overflow-y:auto; text-align:left;">
      <h3>${header}:</h3>
      <ul style="text-align:left;">
        ${errors.map((e) => `<li>${e}</li>`).join("")}
      </ul>
    </div>
    `,
  }).then((result) => {
    if (onOK) {
      return onOK();
    }
  });

  // return showDialog(title, text, "error", onOK);
}


export function showOKCancelDialog(title, text, onOK = null, onCancel = null) {
  let content = '';

  if (Array.isArray(text)) {
    for (const str of text) {
      content += str + " ";
    }
  } else {
    content = text;
  }

  Swal.fire({
    title: title,
    text: content,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "OK",
  }).then((result) => {
    if (result.isConfirmed && onOK) {
      return onOK();
    }
    if (!result.isConfirmed && onCancel) {
      return onCancel();
    }
  });
}

export function showDropInput(title, inputValue) {
  return Swal.fire({
    title: title,
    icon: "info",
    input: "range",
    inputAttributes: {
      min: "0",
      max: "5",
      step: "1",
    },
    inputValue: inputValue,
    showCancelButton: true,
  });
}

export function showToast(type, title, message = null) {
  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    iconColor: "white",
    customClass: {
      popup: "colored-toast",
    },
    showConfirmButton: false,
    timer: 1500,
    timerProgressBar: true,
  });

  let icon = "success";
  switch (type) {
    case "S":
      icon = "success";
      break;
    case "E":
      icon = "error";
      break;
    case "W":
      icon = "warning";
      break;
    case "I":
      icon = "info";
      break;
  }

  const config = {
    icon: icon,
    title: title,
    position: "bottom-end",
  };

  if (!isEmpty(message)) {
    config["text"] = message;
  }

  Toast.fire(config);
}

export function showHtml(title, html) {
  return Swal.fire({
    title: title,
    html: html,
    confirmButtonText: "OK",
  });
}

export function showNumberInput(title, minValue, maxValue, onOK = null) {
  return Swal.fire({
    title: title,
    html: `
    <input
      type="number"
      value="${minValue}"
      step="1"
      class="swal2-input"
      id="range-value">`,
    input: "range",
    minValue,
    inputAttributes: {
      min: minValue,
      max: maxValue,
      step: "1",
    },

    didOpen: () => {
      const inputRange = Swal.getInput();
      const inputNumber = Swal.getPopup().querySelector("#range-value");
      // remove default output
      Swal.getPopup().querySelector("output").style.display = "none";
      inputRange.style.width = "100%";
      // sync input[type=number] with input[type=range]
      inputRange.addEventListener("input", () => {
        inputNumber.value = inputRange.value;
      });
      // sync input[type=range] with input[type=number]
      inputNumber.addEventListener("change", () => {
        inputRange.value = inputNumber.value;
      });
    },
  }).then((result) => {
    if (result.isConfirmed && onOK) {
      return onOK(result.value);
    }
  });
}
